import { defineComponent, PropType } from '@vue/composition-api'
import { BDrugCard } from './BDrugCard'

export const BDrugFetchCard = defineComponent({
  name: 'BDrugFetchCard',
  props: {
    id: {
      type: String,
      required: true,
    },
    width: {
      type: Number,
      default: 360,
    },
    direction: {
      type: String as PropType<'vertical' | 'horizontal'>,
      default: 'horizontal',
    },
    border: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    return {}
  },
  render() {
    return (
      <BDrugCard
        style={{ width: `${this.width}px` }}
        id={this.id}
        direction={this.direction}
        border={this.border}
        onLoaded={() => this.$emit('loaded')}
      ></BDrugCard>
    )
  },
})
